import { NgModule } from '@angular/core';
import { ToAppointmentTimePipe } from './to-appointment-time.pipe';

@NgModule({
  providers: [ToAppointmentTimePipe],
  declarations: [ToAppointmentTimePipe],
  exports: [ToAppointmentTimePipe],
})
export class ToAppointmentTimeModule {}
